/**
 * What each media channel says, given the campaign idea. Demo copy.
 */
import { FACTORS } from "./model";
import { Configuration } from "./types";

export interface ChannelMessage {
  channel: string;
  message: string;
}

/** One line per channel in the selected media plan. */
export const channelMessages = (
  configuration: Configuration
): ChannelMessage[] => {
  const factor = FACTORS.find((f) => f.id === "advertising");
  const option = factor?.options.find(
    (o) => o.value === configuration.advertising
  );
  const messages = MESSAGES[configuration.positioning] ?? MESSAGES.indulgence;
  return (option?.members ?? []).map((id) => ({
    channel: factor?.members?.find((m) => m.id === id)?.label ?? id,
    message: messages[id] ?? "",
  }));
};

/* ── Private ────────────────────────────────────── */

const MESSAGES: Record<string, Record<string, string>> = {
  family: {
    influencer:
      "Parent creators: one jar, zero breakfast negotiations. Lunchbox and after-school ideas.",
    retailMedia:
      "Retailer app and shelf: “The jar the whole family agrees on.” Recipe card with the QR.",
    social:
      "Busy-morning vignettes: toast, pancakes, apple slices. Copy: “Breakfast, settled.”",
    tv: "30s: two kids, two jars, one argument, one Nutella Peanut Butter. Ends on the family table.",
  },
  indulgence: {
    influencer:
      "Food and dessert creators: swirl shots, spoon-from-the-jar moments. “Two classics, one spoon.”",
    retailMedia:
      "Retailer app and end-cap: “Taste it once.” Trial-driving placement next to Nutella.",
    social:
      "6s and 15s taste-led video: the swirl, the crunch, the toast pull. Copy: “Cocoa meets roasted peanut.”",
    tv: "30s brand film: a slow Sunday breakfast, the jar opening, the first spoonful. Nutella joy, peanut twist.",
  },
  natural: {
    influencer:
      "Ingredient-first creators: a jar, the label, the roasted peanuts. No hype, just what is inside.",
    retailMedia:
      "Natural-channel shelf talkers: ingredient list front and center, “Made with real roasted peanuts.”",
    social:
      "Label-reading videos and roasting footage. Copy: “Roasted peanuts. Cocoa. Nothing to hide.”",
    tv: "30s: the peanuts roasting, the cocoa, the jar. A calm voice reads the ingredient list.",
  },
  protein: {
    influencer:
      "Fitness and lifestyle creators: post-workout toast, pre-run spoon. “Fuel that tastes like this.”",
    retailMedia:
      "Sports-nutrition aisle adjacency and app banners: “7g of protein per serving.”",
    social:
      "Short-form gym-to-kitchen clips. Copy: “The snack that pulls its weight.”",
    tv: "30s: morning run, back home, toast with Nutella Peanut Butter. Energy, not dessert.",
  },
};
